import Swal from "sweetalert2";
import Icons from "../../assets/icon";
const SwalAlert = (title, message, icon) => {
  const capitalizeFirstWord = (text) => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1);
  };
  return Swal.fire({
    title: `<span class="custom-toast-title">${capitalizeFirstWord(
      message
    )}</span>`,
    // text: message,
    iconHtml: `<img src="${
      icon === "error" ? Icons?.onErrorIcon : Icons?.onSuccessIcon
    }" alt="icon" class="custom-toast-icon" />`,
    position: "top-end",
    timer: 5000,
    showCloseButton: true,
    showConfirmButton: false,
    timerProgressBar: true,
    toast: true,
    customClass: {
      popup: "my-toast",
      icon: "no-border",
    },
  });
};
export default SwalAlert;
